var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_4256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.379 0.511719C17.9382 0.511719 18.4744 0.733841 18.8698 1.12922C19.2652 1.5246 19.4873 2.06086 19.4873 2.62001V17.378C19.4873 17.9372 19.2652 18.4734 18.8698 18.8688C18.4744 19.2642 17.9382 19.4863 17.379 19.4863H2.62099C2.06183 19.4863 1.52558 19.2642 1.1302 18.8688C0.734818 18.4734 0.512695 17.9372 0.512695 17.378V2.62001C0.512695 2.06086 0.734818 1.5246 1.1302 1.12922C1.52558 0.733841 2.06183 0.511719 2.62099 0.511719H17.379ZM16.8519 16.851V11.264C16.8519 10.3526 16.4899 9.47849 15.8454 8.83402C15.2009 8.18954 14.3268 7.82748 13.4154 7.82748C12.5194 7.82748 11.4758 8.37564 10.9698 9.19787V8.02777H8.02875V16.851H10.9698V11.654C10.9698 10.8423 11.6234 10.1782 12.4351 10.1782C12.8265 10.1782 13.2019 10.3337 13.4786 10.6105C13.7554 10.8872 13.9109 11.2626 13.9109 11.654V16.851H16.8519ZM4.60278 6.37277C5.07247 6.37277 5.52292 6.18618 5.85504 5.85406C6.18716 5.52194 6.37374 5.07149 6.37374 4.6018C6.37374 3.62145 5.58313 2.8203 4.60278 2.8203C4.13029 2.8203 3.67716 3.00799 3.34306 3.34209C3.00897 3.67618 2.82127 4.12932 2.82127 4.6018C2.82127 5.58216 3.62242 6.37277 4.60278 6.37277ZM6.06804 16.851V8.02777H3.14806V16.851H6.06804Z",
    fill: "#01020B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_4256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.edf6e4dc010ce41d47edec457e706e55.svg";
export { ForwardRef as ReactComponent };